import { defineStore } from 'pinia'
import { onValue, child } from "firebase/database";
import { useAuthStore } from './auth';

export const useTableStore = defineStore({
  id: 'table',
  state: () => {
    return {
      zoneList: [],
      zoneListComputed : [],
      zoneSelected:"A",
      table: "A4",
      tables:null,

      //# guest
      myTableItems : [],
      tableState : {},
      
    }
  },
  actions: {
    init(){
      const authStore = useAuthStore()
      
      if(authStore.viewAs == 'guest'){
        this.snapshotTableItems()
        this.snapshotTableState()
      }
    },
    snapshotTableItems(){
      const { tablesRef } = useFirebaseXtable();
      let itemsDataRefs = child(tablesRef(), this.table);
      onValue(itemsDataRefs, (snapshot) => {
        const tableData = snapshot.val()
         this.myTableItems = tableData?.items    
         this.tables = {
          [this.table] : tableData
         } 
        });
    },     

    snapshotTableState(){
      const { tableStateRef } = useFirebaseXtable();
      let stateRefs = child(tableStateRef(), this.table); 
      onValue(stateRefs, (snapshot) => this.tableState = snapshot.val());
    },
  },


})